import { createContext } from "react";

const appointmentContext = createContext();

export default appointmentContext;